module.exports = __webpack_public_path__ + "img/code.97643a49.png";